<template>
  <div>
    <div class="main">
      <img class="check-img" src="@/assets/exit-ic.png" />
      <p class="text-line1">로그아웃</p>
      <p class="text-line2">로그아웃 하시겠습니까?</p>
      <div class="btn-area">
        <button
          :class="{ focused: focusIndex === 0 }"
          @click="backKeyProc"
          @mouseover="focusIndex = 0"
          ref="button"
        >
          되돌아가기
        </button>
        <button
          :class="{ focused: focusIndex === 1 }"
          @click="exit"
          @mouseover="focusIndex = 1"
          ref="button"
        >
          로그아웃
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as deviceApi from "../api/smartTv.js";

export default {
  data() {
    return {
      isActiveVue: true,
      focusIndex: 0,
    };
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
  },
  props: ["type"],
  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
  },
  methods: {
    leftKeyProc(keyInput) {
      if (this.focusIndex === 1) {
        this.focusIndex = 0;
      }
    },
    rightKeyProc(keyInput) {
      if (this.focusIndex === 0) {
        this.focusIndex = 1;
      }
    },
    enterKeyProc(keyInput) {
      if (this.focusIndex === 0) {
        this.backKeyProc();
      } else {
        this.exit();
      }
    },
    backKeyProc(keyInput) {
      this.$router.go(-1);
    },
    exit() {
      this.$store.dispatch("REQUEST_LOGOUT").then((response) => {
        this.$router.replace({
          name: "login",
          params: {
            t: new Date().getTime(),
          },
        });
      });
    },
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  /* margin-top: 310px; */
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
}
.check-img {
  width: 128px;
  height: 128px;
}
.text-line1 {
  font-size: 56px;
  line-height: 1;
  color: #eeeeee;
  margin: 40px 0;
}
.text-line2 {
  font-size: 28px;
  line-height: 1.29;
  color: #888888;
}
button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 80px;
  margin-right: 24px;
  border: none;
}
button.focused {
  border: solid 4px #eeeeee;
}

@media all and (min-width:0px) and (max-width:1280px){
  .check-img {
    width: 128px;
    height: 128px;
    display: none;
  }
  .text-line1 {
    font-size: 56px;
    line-height: 1;
    color: #eeeeee;
    margin: 40px 0;
    display: none;
  }
  .text-line2 {
    font-size: 32px;
    line-height: 1;
    font-weight: bold;
    color: #ffffff;
  }

  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    margin-top: 48px;
    margin-right: 0px;
    border: none;
  }
  button.focused {
    font-weight: bold;
    border: solid 3px #ffffff;
  }

  .btn-area::v-deep button:first-child {
    margin-right: 24px;
  }
}
</style>